import customerApi from 'api/customer';
import CustomerNote from 'models/customerNote';
import customerNotesApi from 'api/customerNotes';
import DeleteConfirm from 'components/forms/deleteConfirm';
import EditableTextArea from 'components/forms/editableTextArea';
import EditableTextField from 'components/forms/editableTextField';
import events from 'lib/events';
import Header from 'components/layout/header';
import IntlWrapper from 'components/layout/intlWrapper';
import Loader from 'components/loader';
import moment from 'moment';
import path from 'path';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import SystemNote from 'models/systemNote';
import systemNotesApi from 'api/systemNotes';
import {dateTimeFormats} from 'helpers/constants';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {newNotesEnabled} from 'features';
let render = (container, params) => {
  console.info('[UI.page.customer.notes] rendering page');

  var _id;
  var _contactid;

  if (params.id) {
    _id = parseInt(params.id.split('.')[0]);
    _contactid = parseInt(params.id.split('.').length > 1 ? params.id.split('.')[1] : null);
  }

  ReactDOM.render(
    <IntlWrapper>
      <WrapperNotes
      customerID={_id}
      contactId={_contactid}
      systemID={parseInt(params.system)} />
    </IntlWrapper>,
    container
  );
  events.publish('page-change', {page: 'customer'});
};

console.info('[UI.page.customer] register route');
//if new notes enabled dont allow user to access old notes display page
if (!newNotesEnabled) {
  router.rr.add([{path: 'customer/:id/notes', handler: routeUtils.requireAuth(render)}]);
  router.rr.add([{path: 'customer/:id/:system/notes', handler: routeUtils.requireAuth(render)}]);
}

function noteSort(a, b) {
  if (a.flag) {
    return -1;
  }
  if (b.flag) {
    return 1;
  }
  return a.lastModified.isBefore(b) ? 1 : -1;
}

function createMarkup(string) {
  let value = string
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\n/g, '<br />');

  return {__html: value};
}

class Notes extends React.Component {
  static propTypes = {
    customerID: PropTypes.number,
    systemID: PropTypes.number,
  };

  constructor(props) {
    super(props);
    let newNote = props.systemID ? new SystemNote({}) : new CustomerNote({});

    this.state = {
      customer: {
        customerContacts: [],
      },
      system: {},
      notes: [],
      loaded: false,
      activeNoteID: -1,
      activeNote: newNote,
      activeNoteBackup: newNote.clone(),
      saving: false,
    };
  }

  componentDidMount() {
    let {formatMessage} = this.props.intl;

    if (!this.props.systemID) {
      let apis = [
        customerApi.getCustomer(this.props.customerID, false),
        customerNotesApi.getList(this.props.customerID),
      ];

      Promise.all(apis)
        .then(([customer, notes]) => {
          this.setState({customer: customer, notes: notes.sort(noteSort), loaded: true});
        })
        .catch(err => {
          console.error(err);
          events.publish('error.user', {message: formatMessage({id: 'notes.error.retrieve.data'})});
        });
    } else {
      systemNotesApi.getList(this.props.systemID)
        .then(notes => {
          this.setState({notes: notes.sort(noteSort), loaded: true});
        })
        .catch(err => {
          console.error(err);
          events.publish('error.user', {message: formatMessage({id: 'notes.error.retrieve.data'})});
        });
    }
  }

  componentWillReceiveProps(newProps) {
    this.props = newProps;
    this.componentDidMount();
  }

  onAdd = (flag) => {
    let newNote;

    if (this.props.systemID) {
      newNote = new SystemNote({
        systemID: this.props.systemID,
        flag: flag,
        lastModified: moment(),
      });
    } else {
      newNote = new CustomerNote({
        customerID: this.props.customerID,
        flag: flag,
        lastModified: moment(),
      });
    }
    this.state.notes.unshift(newNote);
    this.setState({
      activeNoteID: undefined,
      activeNote: newNote,
      activeNoteBackup: newNote,
      notes: this.state.notes,
    });
  };

  onCancel = () => {
    if (!this.state.activeNoteID) {
      this.state.notes.shift();
    }
    this.setState({
      activeNoteID: -1,
      activeNote: this.state.activeNoteBackup.clone(),
      notes: this.state.notes,
    });
  };

  onChange = (data) => {
    this.state.activeNote[data.key] = data.value;
    this.setState({activeNote: this.state.activeNote});
  };

  onDelete = (id) => {
    let note = this.state.notes.find(n => n.id === id);

    note.deleted = true;
    this.setState({notes: this.state.notes});
    this.postChanges(note);
  };

  onEdit = (id) => {
    if (this.state.activeNoteID === -1) {
      let activeNote = this.state.notes.find(note => note.id === id);

      this.setState({
        activeNoteID: id,
        activeNote: activeNote.clone(),
        activeNoteBackup: activeNote.clone(),
      });
    }
  };

  onFlag = (id) => {
    if (this.state.activeNoteID !== -1) {
      if (id !== this.state.activeNoteID) {
        return;
      }
      this.state.activeNote.flag = !this.state.activeNote.flag;
      this.setState({activeNote: this.state.activeNote});
    } else {
      let note = this.state.notes.find(note => note.id === id);
      let activeNote = note.clone();

      activeNote.flag = !activeNote.flag;
      this.setState({
        activeNoteID: id,
        activeNote: activeNote,
        activeNoteBackup: note.clone(),
      });
    }
  };

  onSave = () => {
    this.setState({saving: true});
    let {formatMessage} = this.props.intl;
    // Only one note can be flagged at a time
    let numFlagged = this.state.notes.filter(n => n.flag && !n.deleted);

    if (numFlagged.length > 1) {
      events.publish('error.user', {message: formatMessage({id: 'notes.error.note.flagged'})});
      this.setState({saving: false});
      return;
    }

    // Set last modified to now for notes sort
    this.state.activeNote.lastModified = moment();

    // Post changes to server
    this.postChanges(this.state.activeNote);
  };

  onStar = () => {
    let {formatMessage} = this.props.intl;

    this.state.customer.favourite = !this.state.customer.favourite;
    this.setState({customer: this.state.customer});
    customerApi.saveCustomer(this.state.customer)
      .catch(() => events.publish('error.user', {message: formatMessage({id: 'notes.error.retrieve.data'})}));
  };

  onTopFlag = () => {
    if (this.state.activeNoteID !== -1) {
      this.state.activeNote.flag = !this.state.activeNote.flag;
      this.setState({activeNote: this.state.activeNote});
      return;
    }
    let flaggedNote = this.state.notes.find(n => n.flag);

    if (!flaggedNote) {
      this.onAdd(true);
    } else {
      let activeNote = flaggedNote.clone();

      activeNote.flag = false;
      this.setState({
        activeNoteID: activeNote.id,
        activeNote: activeNote,
        activeNoteBackup: flaggedNote.clone(),
      });
    }
  };

  notesRow = (note) => {
    if (this.state.activeNoteID === note.id) {
      return (
        <tr key={note.id || 0} className='active-note'>
          <td>
            <i className={'pointer fa-2x bl ' + (this.state.activeNote.flag ? 'bl-flag-filled' : 'bl-flag')}
               onClick={this.onFlag.bind(this, note.id)} />
          </td>
          <td className='col-md-2'>
            {moment().format(dateTimeFormats.numeralDate)}
          </td>
          <td>
            <EditableTextField className='b' dataKey='title' value={this.state.activeNote.title} maxLength={75}
                               onChange={this.onChange} editMode={true} validate={val => val && val.trim().length !== 0} />
            <div className='textarea-wrapper'>
              <EditableTextArea dataKey='note' value={this.state.activeNote.note} maxLength={256}
                                onChange={this.onChange} editMode={true} validate={val => val && val.trim().length !== 0} />
            </div>
          </td>
          <td>
            <button className='btn btn-default' onClick={this.onCancel}><FormattedMessage id="general.cancel" /></button>
            <button
              className='btn btn-primary'
              onClick={this.onSave}
              disabled={
                this.state.activeNote.title.trim().length === 0 ||
                this.state.activeNote.note.trim().length === 0 ||
                this.state.saving
              }>
              <FormattedMessage id="general.save" />
            </button>
          </td>
        </tr>
      );
    }

    return (
      <tr key={note.id || 0}>
        <td>
          <i className={'pointer fa-2x bl ' + (note.flag ? 'bl-flag-filled' : 'bl-flag')}
             onClick={this.onFlag.bind(this, note.id)}/>
        </td>
        <td>{note.lastModified ? note.lastModified.format(dateTimeFormats.numeralDate) : ''}</td>
        <td onClick={this.onEdit.bind(this, note.id)}>
          <p>{note.title}</p>
          <p dangerouslySetInnerHTML={createMarkup(note.note)}></p>
        </td>
        <td>
          <DeleteConfirm onDelete={this.onDelete.bind(this, note.id)}/>
        </td>
      </tr>
    );
  };

  notesTable = () => {
    if (this.state.notes.filter(n => !n.deleted).length === 0) {
      return <p className='text-center'><FormattedMessage id="notes.no.notes.display" /></p>;
    }

    let noteRows = this.state.notes.filter(n => !n.deleted).map(note => {
      return this.notesRow(note);
    });

    return (
      <table className='table table-striped table-biolab'>
        <thead>
          <tr>
            <th></th>
            <th><FormattedMessage id="general.date" /></th>
            <th><FormattedMessage id="notes.note.details" /></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {noteRows}
        </tbody>
      </table>
    );
  };

  postChanges = (note) => {
    let {formatMessage} = this.props.intl;

    if (!this.props.systemID) {
      customerNotesApi.save(note, this.props.customerID)
        .then(notes => this.setState({activeNoteID: -1, notes: notes.sort(noteSort), saving: false}))
        .catch(err => {
          console.error(err);
          events.publish('error.user', {message: formatMessage({id: 'notes.error.save.note'})});
        });
    } else {
      systemNotesApi.save(note, this.props.customerID, this.props.systemID)
        .then(notes => this.setState({activeNoteID: -1, notes: notes.sort(noteSort), saving: false}))
        .catch(err => {
          console.error(err);
          events.publish('error.user', {message: formatMessage({id: 'notes.error.save.system'})});
        });
    }
  };

  render() {
    let {formatMessage} = this.props.intl;
    let headerTitle, headerSubTitle, headerStar, contact;
    let mainTitleReturn = path.join(location.hash, '..');

    if (this.props.systemID) {
      headerTitle = 'System';
      headerSubTitle = formatMessage({id: 'general.notes'});
      mainTitleReturn = path.join(mainTitleReturn, 'details'); // Fall back to linking to details page if open in new tab
    } else {
      headerTitle = 'Customer';

      if (this.state.customer.customerContacts.length > 0) {
        contact = this.state.customer.customerContacts[0];

        for (var i = 0; i < this.state.customer.customerContacts.length; i++) {
          if (this.state.customer.customerContacts[i].id === this.props.contactId) {contact = this.state.customer.customerContacts[i];}
        }
        let contactName = contact.nameFirst || contact.nameLast ? (contact.nameFirst || '') + ' ' + (contact.nameLast || '') : contact.organization;

        if (this.state.customer.inactive) {
          headerTitle = <span>{(contactName || '').trim()} <span className='inactive'>(<FormattedMessage id="general.inactive" />)</span></span>;
        } else {
          headerTitle = <span>{(contactName || '').trim()} </span>;
        }
      }

      headerSubTitle = 'Notes';

      headerStar = <i onClick={this.onStar}
                    className={'pointer icon bl ' + (this.state.customer.favourite ? 'bl-star-filled' : 'bl-star')}
                    data-event-category='User' data-event-action='customer-fav' />;
    }
    let isFlagged = this.state.notes.filter(n => !n.deleted).find(n => n.flag);

    return (
      <Loader loaded={this.state.loaded}>
        <div className='notes-page container'>
          <Header mainTitle={headerTitle} subTitle={headerSubTitle} fallbackMainTitleReturn={mainTitleReturn} >
            <button className='btn btn-primary add-button' onClick={this.onAdd.bind(this, false)}
              disabled={this.state.activeNoteID !== -1}>
              <i className='bl bl-add' /> <FormattedMessage id="customer.add.note" />
            </button>
            <i className={'pointer icon bl ' + (isFlagged ? 'bl-flag-filled' : 'bl-flag')}
              onClick={this.onTopFlag} />
            {headerStar}
          </Header>
          {this.notesTable()}
        </div>
      </Loader>
    );
  }
}

const WrapperNotes = injectIntl(Notes);

export default WrapperNotes;
